<template>
  <span style="text-align:left;">
    <template v-if="modo=='new'||modo=='edit'||modo=='flow'">
      <ul>
        <li v-for="(file) in files" :key="file.id">
          <span>{{file.name}}</span> -
          <span>{{Math.round(file.size/1000)+' kb'}}</span> -
          <span v-if="file.error">{{file.error}}</span>
          <span v-else-if="file.success">{{T("Sucesso!")}}</span>
          <span v-else-if="file.active">{{T("carregando...")}}</span>
          <span v-else></span>
        </li>
      </ul>

      <file-upload
        :post-action="endpoint+'/admin/upload/file/upload'"
        :extensions="(campo.arq_tipo!='*' && campo.arq_tipo?campo.arq_tipo:undefined)"
        :accept="(campo.arq_tipo!='*'&& campo.arq_mime?campo.arq_mime:undefined)"
        :multiple="false"
        :size="1024 * 1024 * (campo.arq_tipo!='*' && campo.arq_maxsize?campo.arq_maxsize:999)"
        v-model="files"
        @input-filter="inputFilter"
        @input-file="inputFile"
        ref="upload"
      >
        <v-btn class="right" color="grey">
          <i class="fa fa-plus"></i>
          {{T("Escolher arquivo")}}
        </v-btn>
      </file-upload>

      <div style="text-align:left;" v-if="oldvalue!=null">
        {{T("Arquivo atual:")}}
        <a
          :href="endpoint+`/admin/content/arquivo/${showvalueo}`"
        >{{shownameo}}</a>
        <v-icon color="red" @click="remover()" :title="T('Excluir')" dark>delete</v-icon>
      </div>
      <v-input
        :value="(value)"
        required
        :rules="crud.evalrules(campo)"
        :hint="campo.cmp_dica"
        persistent-hint
      ></v-input>
    </template>

    <template v-if="modo=='list' || modo=='view' || modo=='viewmode'">
      <span :class="{'text-xs-center':modo=='list'}">
        <a v-if="value!=null" :href="endpoint+`/admin/content/arquivo/`+showvalue">{{showname}}</a>
      </span>
    </template>

    <template v-if="modo=='filtro'">
      <v-text-field
        height="20"
        class="ma-0 pa-1"
        hide-details
        v-bind:value="preLoadFiltro(value)"
        v-on:input="(event)=>$emit('input', preUpdateFiltro(event))"
      ></v-text-field>
    </template>
  </span>
</template>
    

<script>
import FileUpload from "vue-upload-component";

try{
  var _baseComponent = require("@/lib/componente/_base.vue").default;
}catch(err){
  var _baseComponent = require("@/framework/lib/componente/_base.vue").default;
}

export default {
  extends: _baseComponent,

  data() {
    return {
      intravalue: this.value,
      oldvalue: this.value,
      files: [],
      endpoint: global.config.endpoint,
    };
  },
  computed: {
    showvalue() {
      if (this.value == null) return null;

      return this.value.split("\n")[0];
    },
    showname() {
      if (this.value == null) return null;

      return this.value.split("\n")[1];
    },
    showvalueo() {
      if (this.oldvalue == null) return null;

      return this.oldvalue.split("\n")[0];
    },
    shownameo() {
      if (this.oldvalue == null) return null;

      return (
        this.oldvalue.split("\n")[1] +
        " (" +
        Math.round(this.oldvalue.split("\n")[2] / 1000) +
        " kb)"
      );
    },
  },
  methods: {
    preUpdate(myval) {
      return myval;
    },
    remover() {
      this.intravalue = null;
      this.oldvalue = null;
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent();
        }
      }
    },
    inputFile(newFile, oldFile) {
      if (newFile && !oldFile) {
        // add
        this.$refs.upload.active = true;
        this.intravalue = this.oldvalue;
      }
      if (newFile && oldFile) {
        // update
        if (newFile.response && newFile.response.data) {
          console.log(newFile);
          this.intravalue =
            newFile.response.data.file +
            "\n" +
            newFile.name +
            "\n" +
            newFile.size;
          console.log(newFile);
        }
      }
      if (!newFile && oldFile) {
        // remove
        this.intravalue = this.oldvalue;
      }
    },
    preLoadFiltro(myval) {
      return myval;
    },
    preUpdateFiltro(myval) {
      return myval;
    },
  },
  mounted() {},

  watch: {
    intravalue(val) {
      this.$emit("input", this.preUpdate(val));
    },
  },
  components: {
    FileUpload,
  },
};
</script>

<style scoped>
</style>

    